export default "__VITE_ASSET__ClLASEKS__"